module.exports = __webpack_public_path__ + "static/media/m-rabbitfarm.448c3d61.png";